module.exports = __webpack_public_path__ + "media/assets/images/tour/3_Tour_1-c68110a004dd5f95289465e095d70c21.jpg";